import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock } from "lucide-react";
import { toast } from "sonner";

const AdminLogin = () => {
  const { admin, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (admin) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, password); nav("/admin/dashboard"); }
    catch { toast.error("Credenziali non valide"); }
    setLoading(false);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <div className="text-center mb-8">
        <Lock className="w-10 h-10 mx-auto text-[#E1BC56] mb-3" strokeWidth={1.4} />
        <div className="text-xs tracking-[0.4em] text-[#E1BC56] font-display mb-2">AREA RISERVATA</div>
        <h1 className="font-display text-3xl font-extrabold text-white tracking-widest">ACCESSO ADMIN</h1>
      </div>
      <form onSubmit={submit} className="bg-[#121214] border border-white/10 rounded-lg p-8 space-y-4" data-testid="admin-login-form">
        <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full bg-[#0B0B0C] border border-white/10 rounded-sm px-3 py-3 text-sm text-white focus:border-[#E1BC56] focus:outline-none" data-testid="admin-email" />
        <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-[#0B0B0C] border border-white/10 rounded-sm px-3 py-3 text-sm text-white focus:border-[#E1BC56] focus:outline-none" data-testid="admin-password" />
        <button disabled={loading} type="submit" className="cmc-btn-gold w-full py-3 rounded-sm" data-testid="admin-login-submit">{loading ? "ACCESSO..." : "ACCEDI"}</button>
      </form>
    </div>
  );
};

export default AdminLogin;
